import { createStore } from 'redux';

import middlewares from './redux/middlewares';
import reducers from './redux/reducers';

const store = createStore(reducers, middlewares);
export default store;
